import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { KeyValue } from '@smartera/core';
import { RestClientService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ComboService {
	public get apiUrl() {
		return Urls.BASE_URL.toString() + '/main/combo';
	}

	public get apiCCUrl() {
		return Urls.BASE_URL.toString() + '/callcenter/combo';
	}

	constructor(private _http: RestClientService) {}

	public getCountrylist(): Observable<KeyValue<string>[]> {
		const body = { valid: true };
		return this._http.post(`${this.apiUrl}/country?size=100`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getCitylist(countryId: string): Observable<KeyValue<string>[]> {
		const body = {
			countryId,
			// valid: true
		};

		return this._http.post(`${this.apiUrl}/city?size=100`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getTownlist(cityId: string): Observable<KeyValue<string>[]> {
		const body = {
			cityId,
			// valid: true
		};

		return this._http.post(`${this.apiUrl}/town?size=100`, JSON.stringify(body)).pipe(
			// tap(console.log),
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getTaxOfficelist(): Observable<KeyValue<string>[]> {
		const body = {};

		return this._http.post(`${this.apiUrl}/tax-office?size=3000`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getTypeDetail(definitionTypeId: string = 'Depo'): Observable<KeyValue<string>[]> {
		const body = {
			definitionTypeId,
			// valid: true
		};
		return this._http.post(`${this.apiUrl}/type-detail`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getDealersList(): Observable<KeyValue<string>[]> {
		const body = {
			// valid: true
		};
		return this._http.post(`${this.apiUrl}/dealer`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.value, value: item.key };
				})
			)
		);
	}

	public getFarmList(vendorId?: string): Observable<KeyValue<string>[]> {
		const body = {
			vendorId,
		};
		return this._http.post(`${Urls.BASE_URL.toString()}/vero-factory-management/combo/farm`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.name, value: item.code };
				})
			)
		);
	}

	public getVendorList(type?: string) {
		const body = {
			valid: true,
			type,
		};
		return this._http
			.post(
				`${Urls.BASE_URL.toString()}/vero-factory-management/vendors/search?page=0&size=1000&sort=creDate,ASC`,
				JSON.stringify(body)
			)
			.pipe(map((result) => result.content));
	}

	public getWrapperList(type?): Observable<KeyValue<string>[]> {
		const body = {
			type,
			valid: true,
		};
		return this._http
			.post(`${Urls.BASE_URL.toString()}/vero-factory-management/combo/wrapper`, JSON.stringify(body))
			.pipe(
				map((arr) =>
					arr.map((item) => {
						return { label: item.name, value: item.code };
					})
				)
			);
	}

	public getCurrency(scope) {
		const body = {
			// scope,
			valid: true,
		};
		return this._http.post(`${this.apiUrl}/currency?size=5&sort=orderNo`, JSON.stringify(body)).pipe(
			map((arr) =>
				arr.map((item) => {
					return { label: item.name, value: item.code };
				})
			)
		);
	}

	public getCustomers(args?: any) {
		const body = {
			valid: true,
			...args,
		};
		return this._http.post(`${this.apiUrl}/customer`, JSON.stringify(body));
	}

	public getBranchsList(args?: any) {
		const body = {
			valid: true,
			...args,
		};
		return this._http
			.post(`${this.apiUrl}/branch`, JSON.stringify(body))
			.pipe(map((res) => res.map((i) => ({ label: i.value, value: i.key }))));
	}

	public getSets(args?: any) {
		const body = {
			valid: true,
			...args,
		};
		return this._http.post(`${this.apiUrl}/set`, JSON.stringify(body));
	}

	public getForms() {
		const body = {
			valid: true,
		};
		return this._http.post(`${this.apiCCUrl}/pm/form`, JSON.stringify(body));
	}

	public getWarehouses(args?) {
		const body = {
			valid: true,
			...args,
		};
		return this._http.post(`${this.apiUrl}/warehouse?size=50`, JSON.stringify(body));
	}

	public getWarehousesByLabelValue(args?) {
		const body = {
			valid: true,
			...args,
		};
		return this._http
			.post(`${this.apiUrl}/warehouse`, JSON.stringify(body))
			.pipe(map((res) => res.map((i) => ({ label: i.name, value: i.code }))));
	}

	// public getWarehousesByCodeName(args?) {
	//   return this.getWarehouses(args)
	//     .pipe(
	//       map(res => res.map(i => ({ name: i.value, code: i.key })))
	//     );
	// }

	public getSuppliers(args?) {
		const body = {
			valid: true,
			...args,
		};

		return this._http.post(`${this.apiUrl}/supplier`, JSON.stringify(body)).pipe(
			map((res) =>
				res.map((i) => ({
					label: i.name,
					value: i.code,
				}))
			)
		);
	}

	public getSuppliersWtihData(args?) {
		const body = {
			isDealer: true,
			valid: true,
			...args,
		};

		return this._http.post(`${this.apiUrl}/supplier`, JSON.stringify(body)).pipe(
			map((res) =>
				res.map((i) => ({
					label: i.name,
					value: i.additionalData.supDealerId,
				}))
			)
		);
	}
}
